<template>
  <div :class="{ 'p-p-3': $route.name == 'AddMoney' }">
    <div class="p-d-flex p-flex-column">
      <span>{{ __("Supplier") }}:</span>
      <p-vue-dropdown
        :options="SuppliersOptions"
        :optionLabel="'NameSupplier'"
        :optionValue="pid"
        :filter="SuppliersOptions.length > 10"
        v-model="moneyLocal.SupplierIDValue"
        class="dropdown"
      >
        <template #value="{ value, placeholder}">
          <div class="inner p-d-flex p-jc-between">
            <span class="value">{{
              value ? value.NameSupplier : placeholder
            }}</span>
            <span class="icon">
              <i-icon name="arrow" />
            </span>
          </div>
        </template>
      </p-vue-dropdown>
      <i-form-error :data="errors.SupplierIDValue"></i-form-error>
    </div>
    <div class="p-d-flex p-flex-column p-mt-2">
      <span>{{ __("Type of Expense") }}:</span>
      <i-override-select-button
        v-model="withOrWithoutItems"
        :options="withOrWithoutItemsOptions"
        :optionLabel="'label'"
        :optionValue="value"
      ></i-override-select-button>
    </div>
    <div
      class="p-my-4"
      v-if="withOrWithoutItems?.value == 1"
      style="color:red; "
    >
      <div class="item-grid p-mb-2">
        <span>{{ __("Item") }}</span>
        <span>{{ __("Count") }}</span>
        <span>{{ __("Delete") }}</span>
      </div>
      <div
        class="item-grid p-mb-2"
        v-for="(item, key) in itemsLocal"
        :key="key"
      >
        <p-vue-dropdown
          :options="ItemsOptions"
          :optionLabel="'ItemName'"
          :optionValue="ItemID"
          :filter="ItemsOptions.length > 10"
          v-model="item.itemValue"
          @change="itemChanged(item, key)"
          class="dropdown"
        >
          <template #value="{ value, placeholder}">
            <div class="inner p-d-flex p-jc-between">
              <span class="value">{{
                value ? value.ItemName : placeholder
              }}</span>
              <span class="icon">
                <i-icon name="arrow" />
              </span>
            </div>
          </template>
        </p-vue-dropdown>
        <p-vue-input-text v-model="item.Qty" @input="updateTRValue" />
        <p-vue-button
          icon="pi pi-trash"
          class="p-button-rounded p-button-danger p-button-outlined p-button-text"
          @click="deleteItem(key)"
        />
      </div>
      <div class="p-d-flex p-jc-end">
        <p-vue-button
          icon="pi pi-plus"
          class="p-button-rounded p-button-success p-button-outlined"
          @click="addItem"
        />
      </div>
    </div>

    <div class="grid">
      <div class="p-d-flex p-flex-column p-mt-2">
        <span>{{ __("Sum") }}:</span>
        <p-vue-input-text
          :disabled="disabledTRValue"
          v-model="moneyLocal.TRValue"
        />
      </div>

      <div class="p-d-flex p-flex-column p-mt-2">
        <span>{{ __("Invoice num") }}:</span>
        <p-vue-input-text v-model="moneyLocal.invoiceNum" />
      </div>
    </div>

    <div class="p-d-flex p-flex-column p-mt-2">
      <span>{{ __("Purpose") }}:</span>
      <p-vue-input-text v-model="moneyLocal.TRPurpose" />
    </div>
    <div class="p-d-flex p-mt-2">
      <div>
        <span>{{ __("special edition") }}:</span>
        <p-vue-radio
          class="p-mx-2"
          name="problems"
          :value="false"
          v-model="moneyLocal.TRNormalExpense"
        />
      </div>
      <div class="p-mr-4">
        <span>{{ __("שוטף") }}:</span>
        <p-vue-radio
          class="p-mx-2"
          name="problems"
          :value="true"
          v-model="moneyLocal.TRNormalExpense"
        />
      </div>
    </div>
    <div class="p-mt-2">
      <span>{{ __("Remarks") }}:</span>
      <p-vue-textarea
        :autoResize="true"
        rows="4"
        class="p-inputtext--alt"
        v-model="moneyLocal.TRNotes"
      />
    </div>
    <div v-if="moreData">
      <div class="grid">
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Reference") }}:</span>
          <p-vue-input-text v-model="moneyLocal.TRRef" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Company share") }}:</span>
          <p-vue-input-text v-model="moneyLocal.TRCompanyShare" />
        </div>
      </div>
      <div class="p-mt-2">
        <span>{{ __("Paid by us for the building") }}:</span>
        <p-vue-checkbox
          class="p-mx-2"
          :binary="true"
          v-model="moneyLocal.PayedByCompany"
        />
      </div>
      <div class="grid">
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("supplier commision") }}:</span>
          <p-vue-input-text v-model="moneyLocal.TRSupplierCommission" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Payment methods") }}:</span>
          <p-vue-dropdown
            :options="PaymentTypesOptions"
            :optionLabel="'PaymentType'"
            :optionValue="MPID"
            :filter="PaymentTypesOptions.length > 10"
            v-model="moneyLocal.MPIDValue"
            class="dropdown"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? value.PaymentType : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown>
        </div>
      </div>
      <div class="grid">
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Bank") }}:</span>
          <p-vue-dropdown
            :options="BanksOptions"
            :optionLabel="'BankName'"
            :optionValue="BankCode"
            :filter="BanksOptions.length > 10"
            v-model="moneyLocal.TRBankValue"
            class="dropdown"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? value.BankName : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Cheque Date") }}:</span>
          <p-vue-calendar
            type="text"
            id="calendar"
            class="p-inputtext--alt no-radius"
            v-model="moneyLocal.TRChequeDate"
          />
        </div>
      </div>
      <div class="grid">
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Account") }}:</span>
          <p-vue-input-text v-model="moneyLocal.TRAccount" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Branch") }}:</span>
          <p-vue-input-text v-model="moneyLocal.TRBranch" />
        </div>
      </div>
    </div>
    <div v-if="!moreData" class="p-d-flex p-jc-center">
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('More details')"
        @click="moreData = !moreData"
      />
    </div>
    <div class="p-d-flex p-jc-between p-mt-4">
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('OK')"
        :loading="loading"
        icon
        @click="showConfirm"
      />
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('Cancel')"
        @click="cancel"
      />
    </div>
  </div>
  <p-get-image v-if="getImage" @getImage="getPictureLocal"></p-get-image>
  <p-vue-confirm-dialog group="headless">
    <template #default="{ message, acceptCallback, rejectCallback }">
      <div
        class="p-d-flex p-flex-column p-ai-center p-p-5 surface-overlay p-border-round"
      >
        <span class="p-font-bold p-text-2xl p-block p-mb-2 p-mt-4">{{
          message.header
        }}</span>
        <p class="p-mb-0">{{ message.message }}</p>
        <div class="p-d-flex p-ai-center p-gap-2 p-mt-4">
          <Button
            label="Save"
            @click="acceptCallback"
            class="p-w-8rem"
          ></Button>
          <Button
            label="Cancel"
            outlined
            @click="rejectCallback"
            class="p-w-8rem"
          ></Button>
        </div>
      </div>
    </template>
  </p-vue-confirm-dialog>
</template>

<script>
import { callProc, apiParam, apiPType, uploadB64 } from "@/services/APointAPI";
import { mapState } from "vuex";
import {
  errorReceived,
  arrayToCsv,
  showSuccessOrFailedModal,
} from "@/services/apointUtil";
import { getPicture } from "@/services/UploadFilesService";
import PGetImage from "@/components/partials/p-get-image";
import { __ } from "@/plugins/i18n/";

export default {
  components: {
    PGetImage,
  },
  props: {
    money: Object,
    close: Function,
  },
  emits: ["moneyChanged"],
  data() {
    return {
      moneyLocal: {},
      itemsLocal: [],
      SuppliersOptions: [],
      ItemsOptions: [],
      BanksOptions: [],
      PaymentTypesOptions: [],
      withOrWithoutItemsOptions: [
        { value: 0, label: __("No items") },
        { value: 1, label: __("With items") },
      ],
      withOrWithoutItems: null,
      errors: { SupplierIDValue: null },
      valid: true,
      moreData: false,
      itemToVModel: null,
      newImage: null,
      getImage: false,
      newTRID: null,
      loading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      callProc("WorkerApp_SuppliersAndItemsLists")
        .then((result) => {
          result = JSON.parse(result);
          this.SuppliersOptions = result.Table;
          this.ItemsOptions = result.Table1;
          this.BanksOptions = result.Table2;
          this.PaymentTypesOptions = result.Table3;
          this.withOrWithoutItems = this.withOrWithoutItemsOptions[0];
          this.moneyLocal = this.money ? this.money : {};

          if (this.isEdit) {
            this.itemsLocal = this.moneyLocal.Items;

            this.moneyLocal.SupplierIDValue = this.SuppliersOptions.find(
              (f) => f.pid == this.money.SupplierID
            );
            this.moneyLocal.MPIDValue = this.PaymentTypesOptions.find(
              (f) => f.MPID == this.money.MPID
            );
            this.moneyLocal.TRBankValue = this.BanksOptions.find(
              (f) => f.BankName == this.money.TRBank
            );

            if (this.itemsLocal.length > 0)
              this.withOrWithoutItems = this.withOrWithoutItemsOptions[1];

            this.itemsLocal.forEach((item) => {
              item.itemValue = this.ItemsOptions.find(
                (f) => f.ItemID == item.ItemID
              );
            });

            if (this.moneyLocal.TRChequeDate)
              this.moneyLocal.TRChequeDate = new Date(
                this.moneyLocal.TRChequeDate
              );
          } else {
            if (this.$route.name == "AddMoney") {
              this.moneyLocal.BID = +this.$route.params.bid;
              this.moneyLocal.PID = -1;
            }
            this.moneyLocal.TRNormalExpense =
              result.Table4[0].MoneyNormalExpense != 0;
            this.moneyLocal.PayedByCompany = false;
            this.moneyLocal.SuppliersCommissionStatuesOfPay = true;
          }
          // console.log(this.moneyLocal);
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived(
            "getData WorkerApp_SuppliersAndItemsLists",
            __("An error occurred")
          );
        });
    },
    validateFields() {
      this.valid = true;
      this.errors.SupplierIDValue = null;
      if (!this.moneyLocal.SupplierIDValue) {
        this.valid = false;
        this.errors.SupplierIDValue = "Required field";
      }
    },
    showConfirm() {
      this.validateFields();
      if (!this.valid) return;

      this.newImage = null;
      this.$confirm.require({
        group: "headless",
        header: __("Adding an invoice"),
        message: __("Do you want to add an invoice for spending?"),
        accept: () => {
          this.addImage();
        },
        reject: () => {
          this.save();
        },
      });
      // this.$confirm.require({
      //   target: event.target,
      //   message: __("Do you want to add an invoice for spending?"),
      //   icon: "pi pi-exclamation-triangle",
      //   accept: () => {
      //     this.addImage();
      //   },
      //   reject: () => {
      //     this.save();
      //   },
      // });
    },
    save() {
      this.$store.dispatch("doLoading", true);
      this.loading = true;
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("TRID", this.moneyLocal.TRID, apiPType.Int),
        apiParam(
          "TRValueDate",
          this.moneyLocal.TRValueDate,
          apiPType.SmallDateTime
        ),
        apiParam("TRSID", this.moneyLocal.SupplierIDValue?.pid, apiPType.Int),
        apiParam(
          "TRPaymentType",
          this.moneyLocal.MPIDValue?.MPID,
          apiPType.Int
        ),
        apiParam("TRValue", +this.moneyLocal.TRValue, apiPType.Real),
        apiParam(
          "TRNormalExpense",
          this.moneyLocal.TRNormalExpense,
          apiPType.Bit
        ),
        apiParam(
          "TRCompanyShare",
          this.moneyLocal.TRCompanyShare,
          apiPType.Float
        ),
        apiParam(
          "TRSupplierCommission",
          this.moneyLocal.TRSupplierCommission,
          apiPType.Float
        ),
        apiParam("TRPurpose", this.moneyLocal.TRPurpose, apiPType.NVarChar),
        apiParam("TRNotes", this.moneyLocal.TRNotes, apiPType.NVarChar),
        apiParam("TRRef", this.moneyLocal.TRRef, apiPType.NVarChar),
        apiParam(
          "PayedByCompany",
          this.moneyLocal.PayedByCompany,
          apiPType.Bit
        ),
        apiParam(
          "TRChequeDate",
          this.moneyLocal.TRChequeDate,
          apiPType.SmallDateTime
        ),
        apiParam(
          "TRBank",
          this.moneyLocal.TRBankValue?.BankName,
          apiPType.NVarChar
        ),
        apiParam("TRBranch", this.moneyLocal.TRBranch, apiPType.NVarChar),
        apiParam("TRAccount", this.moneyLocal.TRAccount, apiPType.NVarChar),
        apiParam("PID", this.moneyLocal.PID, apiPType.Int),
        apiParam("BID", this.moneyLocal.BID, apiPType.Int),
        apiParam("UID", this.moneyLocal.UID, apiPType.Int),
        apiParam("InvoiceNum", this.moneyLocal.invoiceNum, apiPType.NVarChar),
        apiParam(
          "SuppliersCommissionStatuesOfPay",
          this.moneyLocal.SuppliersCommissionStatuesOfPay,
          apiPType.Bit
        ),
        apiParam("ItemsCodeLst", this.getCsvOfItemsIds(), apiPType.VarChar),
        apiParam("ItemsCntLst", this.getCsvOfItemsQty(), apiPType.VarChar),
      ];
      callProc("WorkerApp_UpdateOrInsertMoneyOfProblem", procParams)
        .then((result) => {
          result = JSON.parse(result);
          if (result.procReturnValue == 0) {
            if (!this.isEdit) {
              this.newTRID = result.Table[0].TRID;
              if (this.newTRID && this.newImage) this.upload();
              else {
                showSuccessOrFailedModal(__("Data saved successfully!"));
                this.updateAllMoney();
              }
            } else this.updateAllMoney();
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false, 3000);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch((error) => {
          errorReceived("WorkerApp_UpdateOrInsertProblem", error);
        });
    },
    getCsvOfItemsIds() {
      if (this.withOrWithoutItems?.value == 0) return null;
      let ids = [];
      this.itemsLocal.forEach((f) => {
        ids.push(f.itemValue?.ItemID);
      });
      return arrayToCsv(ids);
    },
    getCsvOfItemsQty() {
      if (this.withOrWithoutItems?.value == 0) return null;
      let qty = [];
      this.itemsLocal.forEach((f) => {
        if (f.itemValue) qty.push(f.Qty);
      });
      return arrayToCsv(qty);
    },
    deleteItem(index) {
      this.itemsLocal.splice(index, 1);
      this.updateTRValue();
    },
    addItem() {
      if (this.itemsLocal.findIndex((f) => !f.itemValue) == -1)
        this.itemsLocal.push({ Qty: 1 });
    },
    updateTRValue() {
      if (this.withOrWithoutItems?.value == 0) {
        this.moneyLocal.TRValue = "";
      } else {
        const sum = this.itemsLocal.reduce((accumulator, object) => {
          return (
            accumulator +
            (object.itemValue ? object.itemValue.ItemPriceVATIncluded : 0) *
              object.Qty
          );
        }, 0);
        this.moneyLocal.TRValue = sum;
      }
    },
    itemChanged(item, index) {
      let i = this.itemsLocal.filter(
        (f) => f.itemValue.ItemID == item.itemValue.ItemID
      );
      if (i.length > 1) {
        errorReceived(
          __("Error"),
          undefined,
          __("It is not possible to insert an item twice")
        );
        this.deleteItem(index);
      }
      this.updateTRValue();
    },
    addImage() {
      this.getImage = false;
      setTimeout(() => {
        this.getImage = true;
      }, 0);
    },
    getPictureLocal(sourceType) {
      getPicture(sourceType, (obj) => {
        this.getImage = false;
        this.newImage = obj;
        this.save();
      });
    },
    upload() {
      //parentType,  parentID,  createdBy,  srcFileName,  base64String,
      uploadB64(
        1,
        this.newTRID,
        this.userNum,
        this.newTRID + ".jpeg",
        this.newImage
      )
        .then((response) => {
          this.$store.dispatch("doLoading", false);
          // console.log(response);
          if (response === true) {
            showSuccessOrFailedModal(__("Image saved successfully"));
            setTimeout(() => {
              this.updateAllMoney();
            }, 1000);
          } else {
            showSuccessOrFailedModal(
              __("There was an error saving the image"),
              false
            );
          }
        })
        .catch((error) => {
          errorReceived("uploadB64 add-money", error);
        });
    },
    updateAllMoney() {
      let reload = this.isEdit ? true : false;
      this.$emit("moneyChanged", reload);
      if (this.$route.name == "AddMoney") {
        this.$router.push({ name: "Dashboard" });
      }
    },
    cancel() {
      if (this.$route.name == "AddMoney")
        this.$router.push({ name: "Dashboard" });
      else this.close();
    },
  },
  computed: {
    disabledTRValue() {
      if (this.withOrWithoutItems?.value == 0) return false;
      return true;
    },
    isEdit() {
      return this.money?.TRID ? true : false;
    },
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
  watch: {
    withOrWithoutItems() {
      this.updateTRValue();
    },
  },
};
</script>

<style scoped>
.p-inputtextarea {
  width: 100%;
}

.icon:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}

.grid {
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;
}

.grid.supplier {
  grid-template-columns: 86% 12%;
}

.item-grid {
  display: grid;
  grid-template-columns: 54% 25% 12%;
  align-items: center;
  gap: 15px;
}
</style>
